var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { omit } from "lodash-es";
import { Component, Mixins } from 'vue-property-decorator';
import devToolMixin from '../../../util/devToolMixin';
let CompInfoPanel = class CompInfoPanel extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.labelCol = {
      span: 4
    };
    this.wrapperCol = {
      span: 14
    };
    this.displayConfig = [{
      id: 'id',
      name: 'ID',
      type: 'string'
    }, {
      id: 'name',
      name: '组件名',
      type: 'string'
    }, {
      id: 'category',
      name: '类别',
      type: 'string'
    }, {
      id: 'type',
      name: '类型',
      type: 'string'
    }, {
      id: 'display',
      name: 'css display',
      type: 'string',
      span: 2
    }, {
      id: 'slots',
      name: '插槽',
      span: 2
    }, {
      id: 'bindings',
      name: '绑定值',
      span: 2
    }, {
      id: 'events',
      name: '事件',
      span: 2
    }, {
      id: 'methods',
      name: '联动方法',
      span: 2
    }];
  }
  get form() {
    return omit(this.ultMeta, ['allowInteropProps', 'component', 'defaultProps', 'fitData', 'getActions', 'propBindings', 'rawMeta', 'meta']);
  }
  getFormField(key) {
    const h = this.$createElement;
    const data = this.form[key];
    const config = this.displayConfig.find(config => config.id === key);
    if (!config) return;
    return h("a-form-item", {
      "attrs": {
        "label": config.name,
        "labelAlign": "left"
      }
    }, [JSON.stringify(data) || '空']);
  }
  getDesc(config) {
    const h = this.$createElement;
    const data = this.form[config.id];
    if (!data) return h("a-descriptions-item", {
      "attrs": {
        "label": config.name,
        "span": config.span || 1
      }
    }, ["\u7A7A"]);
    let dataDisplay;
    switch (config.type) {
      case 'string':
        dataDisplay = h("span", [" ", data, " "]);
        break;
      case 'boolean':
        dataDisplay = h("span", [" ", JSON.stringify(data), " "]);
        break;
      case 'image':
        dataDisplay = h("a-avatar", {
          "attrs": {
            "src": data,
            "shape": "square"
          }
        });
        break;
      default:
        if (!data.length) {
          dataDisplay = '空';
          break;
        }
        switch (config.id) {
          case 'bindings':
          case 'slots':
            dataDisplay = data.map(el => h("a-tag", [" ", el.id, " "]));
            break;
          case 'events':
            dataDisplay = data.map(el => h("a-tag", [" ", el.name, " "]));
            break;
          case 'methods':
            dataDisplay = data.map(el => h("a-tag", [" ", el.title, " "]));
        }
    }
    return h("a-descriptions-item", {
      "attrs": {
        "label": config.name,
        "span": config.span || 1
      }
    }, [dataDisplay]);
  }
  render() {
    const h = arguments[0];
    return h("a-descriptions", {
      "attrs": {
        "title": "组件信息",
        "bordered": true,
        "column": 2
      }
    }, [this.displayConfig.map(config => this.getDesc(config))]);
    return h("a-form", {
      "attrs": {
        "form": this.form,
        "labelCol": this.labelCol,
        "wrapperCol": this.wrapperCol
      }
    }, [this.displayConfig.map(key => this.getFormField(key.id))]);
  }
};
CompInfoPanel = __decorate([Component({
  name: 'CompInfoPanel'
})], CompInfoPanel);
export default CompInfoPanel;
//# sourceMappingURL=CompInfoPanel.js.map
